import { Tabs, useTheme } from '@mui/material';

import { ATSTabbedJobViewNavigationTestIds } from 'data-testids/ATS';
import { CustomTab, tabsSx } from './styles';
import { DesktopNavigationProps } from '../types';

export const DesktopNavigation: React.FC<DesktopNavigationProps> = ({
  bottomTabsData,
  onChange,
  selectedTab,
  topTabsData,
}) => {
  const theme = useTheme();

  return (
    <Tabs
      data-testid={ATSTabbedJobViewNavigationTestIds.DESKTOP_NAVIGATION}
      onChange={onChange}
      orientation="vertical"
      value={selectedTab}
      sx={tabsSx(theme)}
    >
      {topTabsData.map((tab) => (
        <CustomTab
          data-testid={`${ATSTabbedJobViewNavigationTestIds.DESKTOP_TAB}-${tab.value}`}
          key={tab.value}
          label={tab.label}
          sx={{ display: tab.isVisible ? 'block' : 'none', alignItems: 'flex-start' }}
          value={tab.value}
        />
      ))}
      {bottomTabsData.map((tab) => (
        <CustomTab
          data-testid={`${ATSTabbedJobViewNavigationTestIds.DESKTOP_TAB}-${tab.value}`}
          key={tab.value}
          label={tab.label}
          sx={{ display: tab.isVisible ? 'block' : 'none' }}
          value={tab.value}
        />
      ))}
    </Tabs>
  );
};
